import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DashedTitle, Icon } from '@fasstech/middle-design-system';
import { map, path, pathOr } from 'ramda';
import { PricingFormulasCollectiveHealth } from '../../../_common/client/components/PricingFormulas/PricingFormulasCollectiveHealth';
import { ContactSummary } from './ContactSummary';
import { CompanyDemographyInformations } from './CompanyDemographyInformations';
import { useContactRoleLabel } from './useContactRoleLabel';
import { dateTsToFr } from '@@viewHelpers/date.js';
import EffectDateEditField from '@@viewCommonComponents/EffectDateEditField.jsx';
import CompanyContacts from './CompanyContacts';

export const SummaryCollectiveHealth = ({
  getMiddleText, getMiddleBoolean, project, demography, formulaLevelLabel, tariffStructureLabel, regimeObligatoire, onEditEffectDate, editIsLocked, isProjectEditable
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const contacts = pathOr([], ['contacts'], project);
  const company = pathOr(null, ['company'], project);

  const effectDateValue = pathOr(null, ['offer', 'effectDate'], project);
  const effectDate = effectDateValue ? dateTsToFr(effectDateValue) : '';

  const getRoleLabel = useContactRoleLabel(getMiddleText);

  const contactTabs = map((contact) => {
    const role = path(['role'], contact);
    return {
      label: getRoleLabel(role),
      content: <ContactSummary contact={contact} getMiddleText={getMiddleText} />
    };
  }, contacts);

  const hasMultipleContacts = contacts.length > 1;
  const singleContact = contacts.length === 1 ? contacts[0] : null;

  return (
    <div className="flex flex-col items-center gap-4 w-full">
      {company && demography && (
        <CompanyDemographyInformations
          company={company}
          demography={demography}
          getMiddleBoolean={getMiddleBoolean}
          regimeObligatoire={regimeObligatoire}
          isProjectEditable={isProjectEditable}
        />
      )}

      <div className='w-full'>
        <div className="w-full flex justify-center">
          <Icon name="circleGuarantees" size="56" />
        </div>
        <DashedTitle>Garanties</DashedTitle>
        <div className='flex flex-row gap-10'>
          <div className='w-1/6'>
            <EffectDateEditField
              label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
              value={effectDate}
              onEdit={onEditEffectDate}
              editIsLocked={editIsLocked}
              isProjectEditable={isProjectEditable}
            />
          </div>

          <PricingFormulasCollectiveHealth
            prices={project.prices}
            getMiddleText={getMiddleText}
            demography={demography}
            formulaLevelLabel={formulaLevelLabel}
            tariffStructureLabel={tariffStructureLabel}
            beneficiariesEnrollment={project.beneficiariesEnrollment}
          />
        </div>
      </div>

      <CompanyContacts
        hasMultipleContacts={hasMultipleContacts}
        contactTabs={contactTabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        contacts={contacts}
        singleContact={singleContact}
        getMiddleText={getMiddleText}
        isProjectEditable={isProjectEditable}
      />
    </div>
  );
};

SummaryCollectiveHealth.propTypes = {
  getMiddleText: PropTypes.func.isRequired,
  getMiddleBoolean: PropTypes.func,
  project: PropTypes.shape({
    prices: PropTypes.array.isRequired,
    contacts: PropTypes.array,
    company: PropTypes.object
  }).isRequired,
  demography: PropTypes.shape({
    employerPercentShare: PropTypes.number
  }).isRequired,
  formulaLevelLabel: PropTypes.string.isRequired,
  tariffStructureLabel: PropTypes.string.isRequired,
  onEditEffectDate: PropTypes.func,
  editIsLocked: PropTypes.bool
};
